import { render, staticRenderFns } from "./TheSiteHeaderBottom.vue?vue&type=template&id=1ed86ec0&scoped=true&"
import script from "./TheSiteHeaderBottom.vue?vue&type=script&lang=js&"
export * from "./TheSiteHeaderBottom.vue?vue&type=script&lang=js&"
import style0 from "./TheSiteHeaderBottom.vue?vue&type=style&index=0&id=1ed86ec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed86ec0",
  null
  
)

export default component.exports